import React from "react";
import SingleLineJob from "./SingleLineJob";
import ColorfulBox from "./ColorfulBox";

const BuildJob = ({jobTitles, jobTitlesBox}) => {
  return (
    <div className="container px-2 py-3 py-md-5 d-flex flex-column align-items-center">
      <div className="headerText text-center">Build job-ready skills by learning from the best</div>
      <span
      className="text-center py-3"
        style={{
          color: "#FF6D28",
          font: "800 clamp(1.5rem, 2.5vw, 2rem)/normal Nunito",
        }}
      >
       Common job titles
      </span>
      <div className="row align-items-center justify-content-center" style={{gap: 'clamp(1rem, 2.5vw, 2rem)'}}>
        {jobTitles.map((item) => (
            <SingleLineJob item={item} />
        ))}
      </div>
      <div className="header_colorfulBox_container_2 pt-3 pt-md-5">
        {jobTitlesBox.map((item) => (
            <ColorfulBox item={item} />
        ))}
      </div>
    </div>
  );
};

export default BuildJob;
